module.exports = __webpack_public_path__ + "img/Group 1663@2x.19ab936e.png";